import { PDFDocument } from "pdf-lib";
import imageCompression from "browser-image-compression";
import { loadPdfjsDoc, fileToUint8 } from "@/lib/pdfEditor";

export const LEVELS = {
  extreme: { quality: 0.45, maxDim: 1200, scale: 1.0 },
  recommended: { quality: 0.7, maxDim: 1800, scale: 1.5 },
  low: { quality: 0.85, maxDim: 2400, scale: 2.0 },
};

const A4 = [595.28, 841.89];
const dataUrlToBytes = (d) => Uint8Array.from(atob(d.split(",")[1]), (c) => c.charCodeAt(0));

export async function compressPdfFile(file, level, onProgress) {
  const L = LEVELS[level] || LEVELS.recommended;
  const bytes = await fileToUint8(file);
  const src = await loadPdfjsDoc(bytes);
  const out = await PDFDocument.create();
  for (let i = 0; i < src.numPages; i++) {
    const page = await src.getPage(i + 1);
    const vp = page.getViewport({ scale: 1 });
    const cap = L.maxDim / Math.max(vp.width, vp.height);
    const rvp = page.getViewport({ scale: Math.max(0.5, Math.min(L.scale, cap)) });
    const canvas = document.createElement("canvas");
    canvas.width = Math.round(rvp.width);
    canvas.height = Math.round(rvp.height);
    const ctx = canvas.getContext("2d");
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    await page.render({ canvasContext: ctx, viewport: rvp }).promise;
    const jpg = await out.embedJpg(dataUrlToBytes(canvas.toDataURL("image/jpeg", L.quality)));
    const p = out.addPage([vp.width, vp.height]);
    p.drawImage(jpg, { x: 0, y: 0, width: vp.width, height: vp.height });
    if (onProgress) onProgress(i + 1, src.numPages);
  }
  return out.save();
}

export async function compressImagesToPdf(files, level, onProgress) {
  const L = LEVELS[level] || LEVELS.recommended;
  const out = await PDFDocument.create();
  for (let i = 0; i < files.length; i++) {
    const small = await imageCompression(files[i], {
      maxWidthOrHeight: L.maxDim,
      initialQuality: L.quality,
      fileType: "image/jpeg",
      useWebWorker: true,
    });
    const img = await out.embedJpg(new Uint8Array(await small.arrayBuffer()));
    const landscape = img.width > img.height;
    const [pw, ph] = landscape ? [A4[1], A4[0]] : A4;
    const m = 24;
    const s = Math.min((pw - m * 2) / img.width, (ph - m * 2) / img.height);
    const w = img.width * s;
    const h = img.height * s;
    const pg = out.addPage([pw, ph]);
    pg.drawImage(img, { x: (pw - w) / 2, y: (ph - h) / 2, width: w, height: h });
    if (onProgress) onProgress(i + 1, files.length);
  }
  return out.save();
}
